import React from "react";
import "./DegreeCard.css";
import { Fade, Flip } from "react-reveal";
import { style } from "glamor";

function DegreeCard(props) {
  const degree = props.degree;
  const theme = props.theme;

  const style_img = style({
    width: "200px", // Increased from 180px
    height: "200px", // Increased from 180px
    borderRadius: "50%",
    padding: "10px",
    border: `1px solid ${theme.accentColor}`,
    marginRight: "30px",
    boxShadow: `0px 0px 15px ${theme.accentColor}`,
    transition: "all 0.3s ease-in-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.isDark
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(5px)",
    ":hover": {
      transform: "translateY(-5px)",
      boxShadow: `0 10px 30px ${theme.accentColor}`,
    },
    "@media (max-width: 768px)": {
      marginLeft: "auto", // Center horizontally on mobile
      marginRight: "auto", // Center horizontally on mobile
      marginTop: "35px",
      marginBottom: "15px",
      width: "160px",
      height: "160px",
    },
  });

  const card_body = style({
    borderRadius: "16px",
    width: "90%",
    maxWidth: "800px",
    margin: "10px",
    boxShadow: theme.isDark
      ? `0px 10px 30px ${theme.accentBrighter}40`
      : `0px 10px 30px ${theme.accentColor}40`,
    transition: "all 0.3s ease-in-out",
    overflow: "hidden",
    ":hover": {
      transform: "translateY(-5px)",
      boxShadow: theme.isDark
        ? `0 15px 35px 0 ${theme.accentBrighter}70`
        : `0 15px 35px 0 ${theme.accentColor}70`,
    },
    "@media (max-width: 768px)": {
      width: "100%",
    },
  });

  const button_visit = style({
    textDecoration: "none",
    color: "rgba(255, 255, 255, 1)",
    background: `${theme.accentColor}`,
    padding: "12px 20px",
    marginTop: "25px",
    borderRadius: "50px",
    borderWidth: "0px",
    marginBottom: "20px",
    width: "auto",
    minWidth: "150px",
    height: "auto",
    fontWeight: "bold",
    fontFamily: "Google Sans Regular",
    fontSize: "16px",
    transition: "all 0.2s ease-in-out",
    cursor: "pointer",
    textAlign: "center", // Added text alignment
    boxShadow: `0 5px 15px ${theme.accentColor}40`,
    ":hover": {
      color: "rgba(255, 255, 255, 1)",
      transform: "scale(1.05)",
      boxShadow: `0 8px 20px ${theme.accentColor}80`,
    },
  });

  return (
    <div className="degree-card">
      <Flip left duration={1500}>
        <div {...style_img}>
          <img
            style={{
              maxWidth: "85%",
              maxHeight: "85%",
              objectFit: "contain",
              filter: "drop-shadow(0 0 8px rgba(0, 0, 0, 0.3))",
            }}
            src={require(`../../assets/images/${degree.logo_path}`)}
            alt={degree.alt_name}
          />
        </div>
      </Flip>
      <Fade right duration={1500} distance="40px">
        <div {...card_body}>
          <div
            className="body-header"
            style={{
              backgroundColor: theme.accentColor,
              borderRadius: "16px 16px 0 0",
            }}
          >
            <div className="body-header-title">
              <h2 className="card-title" style={{ color: "#FFFFFF" }}>
                {degree.title}
              </h2>
              <h3 className="card-subtitle" style={{ color: "#FFFFFF" }}>
                {degree.subtitle}
              </h3>
            </div>
            <div className="body-header-duration">
              <h3 className="duration" style={{ color: "#FFFFFF" }}>
                {degree.duration}
              </h3>
            </div>
          </div>
          <div className="body-content">
            {degree.descriptions.map((sentence, index) => {
              return (
                <p
                  key={index}
                  className="content-list"
                  style={{ color: theme.text }}
                >
                  {sentence}
                </p>
              );
            })}
            <div style={{ textAlign: "right", marginRight: "23px" }}>
              <a
                href={degree.website_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", display: "inline-block" }}
              >
                <p
                  {...button_visit}
                  style={{
                    textDecoration: "none",
                  }}
                >
                  Visit Website
                </p>
              </a>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

export default DegreeCard;
